<app-header (found)="handleResults($event)"></app-header>
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
<div id="main-wrapper" class="main-background topSpace main-container clinicalContainer">
  <div class="container-fluid" style="padding: 0;">
    <app-search-results [resultGridList]="data"></app-search-results>
    <div class="tab homeAccrordian claimSummaryHeading">
      <h1 class="carelon-page-title m-t-20">Claims List</h1>
      <div class="shadow p-3 mb-5 bg-body rounded">
        <div class="searchContainer row">
          <div class="col-md-4 padLeft0">
            <label class="searchInfo">
              <label>Please search by Provider Name or NPI or Claim ID:</label>
              <input class="form-control" type="text" placeholder="" aria-label="Search"  [(ngModel)]="searchTerm" (keyup) = "search()">
              @if (isNUmber) {
                <span class="smallInfo">You must enter atleast the first 3 digits of the NPI or Claim ID to perform a search</span>
              }
            </label>
          </div>
          <div class="searchOptions radioBtnStyle col-md-8">
            <div class="row">


              <div class="col-md-12">
                <div class="padLeft0">
                  <input type="radio" [(ngModel)]="durtionRadioBtn"  name="searchOptions" [value]="true" (change)="hideDateSelection($event)"/><span>Last 30 days</span><br>
                </div>
              <!-- </div>
              <div class="searchOptions radioBtnStyle col-md-8"> -->

              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class=" padLeft0">
                      <input type="radio" [(ngModel)]="dateRange"  name="searchOptions"  [value]="false" (change)="handleChange($event)"/><span>Date Range</span>
                    </div>
                  </div>

                  @if (showDateSelection) {
                    <div class="col-md-9 dateSelection">
                      <div class="row">
                        <div class="col-md-4">
                          <label><span class="redAtsrik">*</span>START DATE (MM/DD/YYYY)</label>
                          <p-datepicker [(ngModel)]="fromDate" [minDate]="startMinDate" [maxDate]="startMaxDate" [showIcon]="true" dateFormat="mm/dd/yy" [readonlyInput]="true" (onSelect)="onFromSelect($event)" appendTo = "body"></p-datepicker>
                        </div>
                        <div class="col-md-8 pull-left toDate">
                          <div class="row">
                            <div class="col-md-6">
                              <label><span class="redAtsrik">*</span>END DATE (MM/DD/YYYY)</label>
                              <p-datepicker [(ngModel)]="toDate" [minDate]="endMinDate" [maxDate]="endMaxDate" [showIcon]="true" dateFormat="mm/dd/yy" [readonlyInput]="true" [disabled]="disableToDate" (onSelect)="onToSelect($event)" appendTo = "body"></p-datepicker>
                              <p class="endDateErrorMsg">End Date cannot be greater than 30 days from Start Date</p>
                            </div>
                            <div class="col-md-6 button-group">
                              <button (click)="searchClaims()" [disabled]="disableClaimsBtn" class="carelon-primary-btn claimsBtn">Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="pull-left col-md-4 fromDate">
                      <label><span class="redAtsrik">*</span>START DATE (MM/DD/YYYY)</label>
                      <p-datepicker [(ngModel)]="fromDate" [minDate]="startMinDate" [maxDate]="startMaxDate" [showIcon]="true" dateFormat="mm/dd/yy" [readonlyInput]="true" (onSelect)="onFromSelect($event)"></p-datepicker>
                    </div>
                    <div class="col-md-8">
                      <div class="pull-left toDate">
                        <label><span class="redAtsrik">*</span>END DATE (MM/DD/YYYY)</label>
                        <p-datepicker [(ngModel)]="toDate" [minDate]="endMinDate" [maxDate]="endMaxDate" [showIcon]="true" dateFormat="mm/dd/yy" [readonlyInput]="true" [disabled]="disableToDate" (onSelect)="onToSelect($event)"></p-datepicker>
                        <p class="endDateErrorMsg">End Date cannot be greater than 30 days from Start Date</p>
                      </div>
                      <div class="pull-left claimsBtnContainer">
                      </div>
                    </div> -->
                  </div>
                }
              </div>
              
              <!-- Submit Dispute Button - Always Visible -->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 dispute-button-container">
                    <button type="button" 
                            class="btn carelon-primary-btn submit-dispute-btn" 
                            [disabled]="!selectedClaimId"
                            (click)="openDisputeModal()">
                      Submit Dispute
                    </button>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="row clinicalContent whiteBg tableShadow claimPage">
        <div class="col-lg-12 padmar0">
          @if (providerClaimData.length > 0) {
            <span>
              @if (showClaimsResults) {
                <h4 class="claimResultsInfo">Showing claims from {{fromDateWithFormat}} through {{toDateWithFormat}} (maximum 100 claims are displayed): </h4>
              }
              @if (showClaimsResultsForLast30Days) {
                <h4 class="claimResultsInfo">Showing claims for the last 30 days  (maximum 100 claims are displayed): </h4>
              }
            </span>
          }
          <div class="col-md-12 usersite-column tab-content cup-grid-footer-align message-grid cup-grid-bottom">
            <div class="row">
              <div class="memberContainer mainClinicalTable claimSummaryTable">
                <div class="memberContainer mainClinicalTable">
                  <table class="table custom-table myTable clinicalTable stcikyHeaders" id="myTable">
                    <thead>
                      <tr class="table-header stickyHeader">
                        <th class="select-dispute">Select</th>
                        <th class="prh">Provider</th>
                        <th class="pnpi">NPI</th>
                        <th class="pcl">Claim No</th>
                        <th>Member ID</th>

                        <th>Member Name</th>
                        <th class="fh">First Date of Service</th>
                        <th>Claim ReceivedDate</th>
                        <!-- <th class="dh">Diagnosis</th> -->
                        <th class="bh">Billed</th>
                        <th class="pyh">Pay Amount</th>
                        <!-- <th class="cch">Capitation Code</th> -->
                        <th class="cdh">Capitation Description</th>
                        <th class="nih">Network Indicator</th>
                        <th class="sh">Status</th>
                      </tr>
                    </thead>
                    <tbody class="">
                      <ng-container *ngFor="let provider of providerClaimData | paginate: { itemsPerPage: 10, currentPage: p } as results; index as rowIndex">
                        <tr >
                          <td class="text-center">
                            <input type="checkbox" 
                                   [checked]="selectedClaimId === provider.details.claimId"
                                   (change)="onClaimSelection(provider)">
                          </td>
                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.provider.name}}
                            </a>
                          </td>
                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.provider.npi}}
                            </a>
                          </td>
                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              <span class="claimNo">{{provider.details.claimId}}</span>
                            </a>
                          </td>

                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.details.memberId}}
                            </a>
                          </td>

                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.details.memberName}}
                            </a>
                          </td>
                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.details.firstDateOfService | date}}
                            </a>
                          </td>
                          <td >
                            <a class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                              {{provider.details.claimReceivedDate | date}}
                            </a>
                          </td>
                          <!--  <td title="{{provider.diagnosisCodes}}">
                          <a routerLink="saveStateAndNavigate(provider.details.claimId)">
                            {{(provider.diagnosisCodes.length > 10)? (provider.diagnosisCodes | slice:0:10)+'...':(provider.diagnosisCodes)}}
                          </a>
                        </td> -->
                        <td>
                          <a class="dollarSign changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                            {{provider.details.billed | number : '1.2-2'}}
                          </a>
                        </td>
                        <td >
                          <a class="dollarSign changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                            {{provider.details.payAmount | number : '1.2-2' }}
                          </a>
                        </td>
                        <!--  <td>
                        <a routerLink="saveStateAndNavigate(provider.details.claimId)">
                          {{provider.details.capitationCode}}
                        </a>
                      </td> -->
                      <td >
                        <a  class ="changepointer"(click)="saveStateAndNavigate(provider.details.claimId)">
                          {{provider.details.capitationDesc}}
                        </a>
                      </td>
                      <td >
                        <a  class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                          {{provider.details.networkInd}}
                        </a>
                      </td>
                      <td>
                        <a  class ="changepointer" (click)="saveStateAndNavigate(provider.details.claimId)">
                          <span class="badge">{{provider.details.statusDesc}}</span>
                        </a>
                      </td>
                    </tr>
                  </ng-container>
                  @if (providerClaimData.length==0) {
                    <tr>
                      <td colspan="13" class="noRecordsF">No records found.</td>
                    </tr>
                  }
                  <!-- <li *ngFor="let provider of provid erClaimData">
                  <a routerLink="/providerportal/claimsummarydetail/{{provider.id}}">
                    <span class="badge">{{provider.id}}</span> {{provider.name}}
                  </a>
                </li> -->
                <tr align="center" class="paginationTab">
                  <td colspan="13" ><pagination-controls (pageChange)="p = $event"></pagination-controls>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>

<!-- Material Dialog is handled in the component TypeScript file -->

<br><br><br><br><br><br>
<app-footer></app-footer>